import { Tag } from "antd";
import { OrderTransportConstant } from "../core/_constant";

enum STATUS {
  CREATED = OrderTransportConstant.CREATED as any,
  ASSIGNED = OrderTransportConstant.ASSIGNED as any,
  PENDING_RESTITUTION = OrderTransportConstant.PENDING_RESTITUTION as any,
  RESTITUE = OrderTransportConstant.RESTITUE as any,
}

export const getStatusTag = (
  status: keyof typeof STATUS,
  label: string
): React.ReactNode => {
  switch (status) {
    case "CREATED":
      return <Tag>{label}</Tag>;
    case "ASSIGNED":
      return <Tag color="processing">{label}</Tag>;
    case "PENDING_RESTITUTION":
      return <Tag color="warning">{label}</Tag>;
    case "RESTITUE":
      return <Tag color="success">{label}</Tag>;

    default:
      return <Tag>{label}</Tag>;
  }
};
